// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"f611774c","703":"6e59efc1","787":"bdb4181a"}[chunkId] + ".chunk.js";
};